/* ==========================================================================
   SearcherFli > Client > Store > Reducer
   ========================================================================== */

/* Modules */
const { types } = require('./actions');

const { ROUNDTRIP } = require('../product/constants');

/* Initial state */
const initialState = {
    origin: null,
    destination: null,
    calendar: null,
    passengers: null,
    passengersCount: 0,
    classes: 0,
    discount: 0,
    airline: null,
    options: null,
    product: ROUNDTRIP,
    paxesNames: '',
    travelPolicy: '',
    directFlights: false
};

/* Reducer */
// eslint-disable-next-line
function reducer(state = initialState, action) {
    switch (action.type) {
        case types.ADD_PAXES_NAMES:
            return {
                ...state,
                paxesNames: action.payload
            };
        case types.ADD_TRAVEL_POLICY:
            return {
                ...state,
                travelPolicy: action.payload
            };
        case types.ADD_DIRECT_FLIGHTS:
            return {
                ...state,
                directFlights: action.payload
            };

        case types.CHANGE_ORIGIN:
            return {
                ...state,
                origin: action.payload
            };
        case types.CHANGE_DESTINATION:
            return {
                ...state,
                destination: action.payload
            };
        case types.CHANGE_CALENDAR:
            return {
                ...state,
                calendar: action.payload
            };
        case types.CHANGE_PASSENGERS:
            return {
                ...state,
                passengers: {
                    ...state.passengers,
                    ...action.payload
                },
                passengersCount:
                    (action.payload.adults || state.passengers.adults) +
                    (action.payload.babies || state.passengers.babies) +
                    (action.payload.children || state.passengers.children)
            };
        case types.CHANGE_PRODUCT:
            return {
                ...state,
                product: action.payload
            };
        case types.CHANGE_CLASSES:
            return {
                ...state,
                classes: action.payload
            };
        case types.CHANGE_DISCOUNT:
            return {
                ...state,
                discount: action.payload
            };
        case types.CHANGE_AIRLINES:
            return {
                ...state,
                airline: action.payload
            };
        case types.CHANGE_OPTIONS:
            return {
                ...state,
                options: action.payload
            };
        case types.SET_SEARCHER:
            return {
                ...state,
                ...action.payload
            };
        case types.DESTROY:
        default:
            return state;
    }
}

/* Initial state */
const initialStateOpenjaw = {
    rows: []
};

/* Reducer openjaw */
function reducerOpenjaw(state = initialStateOpenjaw, action) {
    switch (action.type) {
        case types.CHANGE_ROW:
            return {
                ...state,
                rows: state.rows.map(item => {
                    if (item.index !== action.payload.index) return item;

                    return {
                        ...item,
                        ...action.payload
                    };
                })
            };
        case types.SET_ROW:
            return {
                ...state,
                rows: state.rows[action.payload.index]
                    ? state.rows.map(item => {
                          if (item.index !== action.payload.index) return item;

                          return {
                              ...item,
                              ...action.payload
                          };
                      })
                    : [...state.rows, action.payload]
            };
        case types.REMOVE_ROW:
            return {
                ...state,
                rows: state.rows.filter(item => {
                    if (item.index === action.payload) return false;

                    return {
                        ...item,
                        ...action.payload
                    };
                })
            };
        default:
            return state;
    }
}

/* Reducer cross selling */
function reducerCrossSelling(state = { includeHotels: false }, action) {
    switch (action.type) {
        case types.CHANGE_CROSSSELLING:
            return {
                ...state,
                includeHotels: action.payload
            };
        default:
            return state;
    }
}

/* Exports */
module.exports = {
    reducer,
    reducerOpenjaw,
    reducerCrossSelling
};
